<script lang="ts" setup>
import AppBreadcrumb from '~/components/layout/AppBreadcrumb.vue'
import AppFooter from '~/components/layout/AppFooter.vue'
import AppSidebar from '~/components/layout/AppSidebar.vue'
import AppTopbar from '~/components/layout/AppTopbar.vue'
import ConfirmDelete from '~/components/dialogs/ConfirmDelete.vue'

const { initTheme, layoutConfig, layoutState } = useTemplateLayout()
const { siteName } = useSite()

const outsideClickListener = ref<(event: Event) => any>()

const containerClass = computed(() => {
  return {
    'layout-overlay': layoutConfig.value.menuMode === 'overlay',
    'layout-static': layoutConfig.value.menuMode === 'static',
    'layout-static-inactive':
      layoutState.value.staticMenuDesktopInactive &&
      layoutConfig.value.menuMode === 'static',
    'layout-overlay-active': layoutState.value.overlayMenuActive,
    'layout-mobile-active': layoutState.value.staticMenuMobileActive,
  }
})

function bindOutsideClickListener() {
  if (!outsideClickListener.value) {
    outsideClickListener.value = (event: Event) => {
      if (isOutsideClicked(event)) {
        layoutState.value.overlayMenuActive = false
        layoutState.value.staticMenuMobileActive = false
        layoutState.value.menuHoverActive = false
      }
    }
    document.addEventListener('click', outsideClickListener.value)
  }
}

function unbindOutsideClickListener() {
  if (outsideClickListener.value) {
    document.removeEventListener('click', outsideClickListener.value)
    outsideClickListener.value = undefined
  }
}

function isOutsideClicked(event: Event) {
  const sidebarEl = document.querySelector('.layout-sidebar')
  const topbarEl = document.querySelector('.layout-menu-button')

  return !(
    sidebarEl?.isSameNode(event.target as Node) ||
    sidebarEl?.contains(event.target as Node) ||
    topbarEl?.isSameNode(event.target as Node) ||
    topbarEl?.contains(event.target as Node)
  )
}

onBeforeMount(() => {
  initTheme()
})

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} | ${siteName.value}` : siteName.value
  },
})

watch(
  () => layoutState.value.overlayMenuActive,
  (newVal) => {
    if (newVal) {
      bindOutsideClickListener()
    } else {
      unbindOutsideClickListener()
    }
  }
)
</script>

<template>
  <div class="layout-wrapper" :class="containerClass">
    <app-topbar></app-topbar>
    <app-sidebar></app-sidebar>
    <div class="layout-main-container">
      <div class="layout-main">
        <app-breadcrumb />
        <NuxtPage />
      </div>
      <app-footer></app-footer>
    </div>
    <div class="layout-mask animate-fadein"></div>
  </div>

  <ConfirmDialog />

  <ConfirmDialog group="delete">
    <template #container="props">
      <ConfirmDelete v-bind="props" />
    </template>
  </ConfirmDialog>

  <DynamicDialog />

  <Toast />
</template>
